import { SimpleButton, SimpleTextField } from '@/src/ui';

interface AdminViewStudentSearchProps {
    adminViewStudentId: string;
    setAdminviewStudentId: (val: string) => void;
    refreshTableData: (studentId?: string) => Promise<void>;
}

export default function AdminViewStudentSearch(props: AdminViewStudentSearchProps) {
    const { adminViewStudentId, setAdminviewStudentId, refreshTableData } = props;

    return (
        <div className="flex flex-row items-end gap-4">
            <SimpleTextField
                name="adminViewStudentId"
                label="Admin Student ID search"
                value={adminViewStudentId.toString() || ''}
                onChange={(e) => setAdminviewStudentId(e.target.value)}
                sx={{ minWidth: 200, maxWidth: 300 }}
            />
            <SimpleButton onClick={() => refreshTableData(adminViewStudentId)} color="primary">
                Search
            </SimpleButton>
        </div>
    );
}
